<ng-container *ngIf="aumFormControl == null; else toggleWithFormControl">
    <mat-slide-toggle (change)="onToggleChange($event)" [disabled]="disabled" [checked]="checked">
        {{ caption }}
    </mat-slide-toggle>
</ng-container>

<ng-template #toggleWithFormControl>
    <mat-slide-toggle [formControl]="aumFormControl" (change)="onToggleChange($event)" [disabled]="disabled">
        {{ caption }} <ng-content></ng-content>
    </mat-slide-toggle>
</ng-template>
